import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';

export interface ComponentCanDeactivate {
  canDeactivate(): boolean | Promise<boolean>;
}

/** Generic "confirm before leaving" guard — delegates entirely to the component's own
 *  canDeactivate(), so it works for any component that implements ComponentCanDeactivate.
 *  Applies to browser Back/Forward as well as in-app router navigation, since both go through
 *  Angular's router. */
@Injectable({
  providedIn: 'root'
})
export class UnsavedChangesGuard implements CanDeactivate<ComponentCanDeactivate> {
  canDeactivate(component: ComponentCanDeactivate): boolean | Promise<boolean> {
    return component.canDeactivate ? component.canDeactivate() : true;
  }
}
